import React from 'react'

const UnsubscribeScreen = () => {
  return (
    <div className="bg-bgColor h-screen">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <h1 className='text-3xl font-extrabold tracking-tight text-gray-900 mb-8 text-center '>
              Fill in your email below and you won't receive any more emails from us. You can <a href="/" className="text-mainTheme">rejoin</a> at any time.
            </h1>
            <form action="https://formsubmit.co/samzi.henderson@gmail.com" className="mt-12 sm:max-w-lg sm:w-full sm:flex align-middle justify-center text-center" method="POST">
                <div className="min-w-0 flex-1">
                    <label htmlFor="hero-email" className="sr-only">
                      Email address
                    </label>
                    <input
                      id="hero-email"
                      type="email"
                      className="block w-full border border-gray-300 rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:border-mainTheme focus:ring-mainTheme"
                      placeholder="Enter your email"
                      name="email"
                      required
                    />
                  </div>
                  <div className="mt-4 sm:mt-0 sm:ml-3">
                    <button
                      type="submit"
                      className="block w-full rounded-md border border-transparent px-5 py-3 bg-mainTheme text-base font-medium text-white shadow hover:bg-mainThemeTinted focus:outline-none focus:ring-2 focus:ring-mainTheme focus:ring-offset-2 sm:px-10"
                    >
                      Unsubscribe
                    </button>
                  </div>
                  <input type="hidden" name="_next" value="https://ahra.in/unsubscribe-successful"/>
                  <input type="hidden" name="_subject" value="Unsubscribe from Ahrain requested"/>
                  <input type="hidden" name="_cc" value="team@ahra.in"/>
                </form>
        </div>
     </div>
  )
}

export default UnsubscribeScreen